import { http } from '../../../plugins/axios'

const actions = {
  get ({commit}, payload) {
    let url = `site`
    let options = {
      emulateJSON: false
    }
    let params = {
      "perPage": payload.event.item.perPage,
      "page": payload.event.item.page,
      "sortKey": payload.event.item.sortKey ? payload.event.item.sortKey  : 'id',
      "ord": payload.event.item.ord,
      "find": payload.event.item.find !== '' ? payload.event.item.find : undefined
    }
    http.get(url, { params }, options)
      .then(response => {
        commit('onGet',  {event: payload.event, response})
      },
      error => {
        payload.event.context.showNotification(error.response, 'error')
      })
  },
  getByUser ({commit}, payload) {
    let url = `site-user`
    let options = {
      emulateJSON: false
    }
    http.get(url, {}, options)
      .then(response => {
        commit('onGetByUser',  {event: payload.event, response})
      },
      error => {
        payload.event.context.showNotification(error.response, 'error')
      })
  },
  getById({commit}, payload) {
    let url = `site/${payload.event.id}`
    let options = {
      emulateJSON: false
    }
    http.get(url, {}, options)
      .then(
        response => {
          commit ('onGetById', {event: payload.event, response})
        },
        error => {
          commit('onError', {event: payload.event, error})
        }
      )
  },
  post ({commit}, payload) {
    let url = 'site'
    let params = {
      "name": payload.event.item.name,
      "lat": payload.event.item.lat,
      "lng": payload.event.item.lng,
      "external_inspections": payload.event.item.external_inspections,
      "street": payload.event.item.address.street,
      "street_number": payload.event.item.address.street_number,
      "suburb": payload.event.item.address.suburb,
      "city": payload.event.item.address.city,
      "state": payload.event.item.address.state,
      "country_id": payload.event.item.address.country_id,
      "zip_code": payload.event.item.address.zip_code,
      "manager": payload.event.item.manager,
      "email": payload.event.item.email,
      "phone": payload.event.item.phone,
      "additional_info": payload.event.item.additional_info
    }
    http.post(url, params, {})
      .then(
        response => {
          commit('onPost', {event: payload.event, response})
        },
        error => {
          commit('onError', {event: payload.event, error})
        }
      )
  },
  put ({commit}, payload) {
    let url = `site/${payload.event.item.id}`
    let params = {
      "name": payload.event.item.name,
      "lat": payload.event.item.lat,
      "lng": payload.event.item.lng,
      "external_inspections": payload.event.item.external_inspections,
      "street": payload.event.item.address.street,
      "street_number": payload.event.item.address.street_number,
      "suburb": payload.event.item.address.suburb,
      "city": payload.event.item.address.city,
      "state": payload.event.item.address.state,
      "country_id": payload.event.item.address.country_id,
      "zip_code": payload.event.item.address.zip_code,
      "manager": payload.event.item.manager,
      "email": payload.event.item.email,
      "phone": payload.event.item.phone,
      "additional_info": payload.event.item.additional_info
    }
    http.put(url, params, {})
      .then(
        response => {
          commit('onPut', {event: payload.event, response})
        },
        error => {
          commit('onError', {event: payload.event, error})
        }
      )
  },
  delete ({commit}, payload) {
    let url = `site/${payload.event.item.id}`
    http.delete(url, {}, {})
      .then(
        response => {
          commit('onDelete', {event: payload.event, response})
        },
        error => {
          commit('onError', {event: payload.event, error})
        }
      )
  },
  deleteUser ({commit}, payload) {
    let url = `del-site-user/${payload.event.item.user.id}/${payload.event.item.site}`
    http.delete(url, {}, {})
      .then(
        response => {
          commit('onDeleteUser', {event: payload.event, response})
        },
        error => {
          commit('onError', {event: payload.event, error})
        }
      )
  },
  addUsers ({commit}, payload) {
    let url = 'site-user'
    let params = {
      "site_id": payload.event.item.id,
      "users": payload.event.item.users
    }
    http.post(url, params, {})
      .then(
        response => {
          commit('onAddUsers', {event: payload.event, response})
        },
        error => {
          commit('onError', {event: payload.event, error})
        }
      )
  }
}

export default actions